import React, { Suspense } from "react";

import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from "./theme";

import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import StoreHolder from "./StoreHolder";

import { Amplify, Auth } from 'aws-amplify';
import { AWSIoTProvider } from "@aws-amplify/pubsub";
import AuthWrapper from "./AuthWrapper";
import awsconfig from "./aws-exports";
import { Authenticator } from '@aws-amplify/ui-react';

import { Oval } from 'react-loader-spinner';
import palette from './theme/palette';

import './i18n';
import { safeParseLocalStorage } from "./utils/safeParseLocalStorage";

Amplify.Logger.LOG_LEVEL = "ERROR";

localStorage.setItem("rawbucket", awsconfig.aws_user_files_s3_bucket);
localStorage.setItem("bucket", `${awsconfig.aws_user_files_s3_bucket}/public`);

Amplify.configure({
  ...awsconfig,
  Analytics: {
    disabled: true,
  },
  API: {
    endpoints: [
      {
        name: "AWSApiGateway",
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        custom_header: async () => {
          let klient = localStorage.getItem("klient")
            ? safeParseLocalStorage("klient", {}).boerderyuuid
              ? safeParseLocalStorage("klient", {}).boerderyuuid
              : null
            : null;
          let boerdery = localStorage.getItem("boerdery")
            ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              : null
            : null;
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            boerderyuuid: !klient
              ? boerdery
              : klient === boerdery
                ? boerdery
                : klient,
            spuuid: klient ? boerdery : null,
          };
        },
      },
      {
        name: "API_Aktiwiteite",
        endpoint: process.env.REACT_APP_API_ENDPOINT_AKTIWITEITE,
        custom_header: async () => {
          let klient = localStorage.getItem("klient")
            ? safeParseLocalStorage("klient", {}).boerderyuuid
              ? safeParseLocalStorage("klient", {}).boerderyuuid
              : null
            : null;
          let boerdery = localStorage.getItem("boerdery")
            ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              : null
            : null;
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            boerderyuuid: !klient
              ? boerdery
              : klient === boerdery
                ? boerdery
                : klient,
            spuuid: klient ? boerdery : null,
          };
        },
      },
      {
        name: "API_Pluk",
        endpoint: process.env.REACT_APP_API_ENDPOINT_PLUK,
        custom_header: async () => {
          let klient = localStorage.getItem("klient")
            ? safeParseLocalStorage("klient", {}).boerderyuuid
              ? safeParseLocalStorage("klient", {}).boerderyuuid
              : null
            : null;
          let boerdery = localStorage.getItem("boerdery")
            ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              : null
            : null;
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            boerderyuuid: !klient
              ? boerdery
              : klient === boerdery
                ? boerdery
                : klient,
            spuuid: klient ? boerdery : null,
          };
        },
      },
      {
        name: "API_SP",
        endpoint: process.env.REACT_APP_API_ENDPOINT_SP,
        custom_header: async () => {
          let klient = localStorage.getItem("klient")
            ? safeParseLocalStorage("klient", {}).boerderyuuid
              ? safeParseLocalStorage("klient", {}).boerderyuuid
              : null
            : null;
          let boerdery = localStorage.getItem("boerdery")
            ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              : null
            : null;
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            spuuid: klient ? boerdery : null,
          };
        },
      },
      {
        name: "API_Billing",
        endpoint: process.env.REACT_APP_API_ENDPOINT_BILLING,
        custom_header: async () => {
          let klient = localStorage.getItem("klient")
            ? safeParseLocalStorage("klient", {}).boerderyuuid
              ? safeParseLocalStorage("klient", {}).boerderyuuid
              : null
            : null;
          let boerdery = localStorage.getItem("boerdery")
            ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              ? safeParseLocalStorage("boerdery", {}).boerderyuuid
              : null
            : null;
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            boerderyuuid: !klient
              ? boerdery
              : klient === boerdery
                ? boerdery
                : klient,
            spuuid: klient ? boerdery : null,
          };
        },
      },
    ],
  },
});
Amplify.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: process.env.REACT_APP_AWS_PUBSUB_REGION,
    aws_pubsub_endpoint: process.env.REACT_APP_AWS_PUBSUB_ENDPOINT,
  })
);
Auth.configure({ ...awsconfig, mandatorySignIn: false });

const App = (props) => {
  return (
    <Suspense fallback={<Oval
      color={palette.secondary.main}
      secondaryColor={palette.secondary.light}
      wrapperStyle={{ justifyContent: "center" }}
    />}>
      <StoreHolder>
        <DndProvider backend={HTML5Backend}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <Authenticator.Provider>
                <AuthWrapper />
              </Authenticator.Provider>
            </ThemeProvider>
          </StyledEngineProvider>
        </DndProvider>
      </StoreHolder>
    </Suspense >
  );
};

export default App;
